"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("@emotion/react/jsx-runtime");
const styled_1 = __importDefault(require("../../styles/styled"));
const theme_1 = __importDefault(require("../../styles/theme"));
const spinner_1 = require("../spinner/spinner");
const Overlay = styled_1.default.div({
    background: 'rgba(255,255,255,0.5)',
    textAlign: 'center',
    position: 'relative',
    height: 'calc(100vh - 250px)',
    width: '100%',
});
const SpinnerContainer = styled_1.default.div({
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
});
const LoadingOverlay = () => {
    return ((0, jsx_runtime_1.jsx)(Overlay, { children: (0, jsx_runtime_1.jsx)(SpinnerContainer, { children: (0, jsx_runtime_1.jsx)(spinner_1.Spinner, { size: "40px", color: theme_1.default.colors.grey30 }) }) }));
};
exports.default = LoadingOverlay;
//# sourceMappingURL=loading_overlay.js.map